export default "__VITE_PUBLIC_ASSET__a9d90723__"